export default class Format {
  static dollars(cents, includeSymbol = true) {
    var prefix
    if (includeSymbol) {
      prefix = "$"
    } else {
      prefix = ""
    }
    if (cents % 100 === 0)
      return `${prefix}${cents / 100}`
    else
      return `${prefix}${(cents / 100).toFixed(2)}`
  }

  static isoDate(date) {
    return [
      date.getFullYear(),
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getDate().toString().padStart(2, '0')
    ].join("-")
  }
}
